import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Brand } from '../interfaces/brand';
// لو عامل الموديل اللي كتبناه قبل كده

@Injectable({
  providedIn: 'root',
})
export class BrandService {
  private baseUrl = `${environment.Server_URL}/brands`;

  constructor(private http: HttpClient) {}

  // ✅ Get all brands (with optional pagination)
  getAll(warehouse: any, perPage: number = 10, page: number = 1): Observable<any> {
    const params = new HttpParams()
      .set('warehouse_id', warehouse)
      .set('per_page', perPage.toString())
      .set('page', page.toString());
    return this.http.get<any>(this.baseUrl, { params });
  }

  // ✅ Get single brand by id
  getById(id: number): Observable<Brand> {
    return this.http.get<Brand>(`${this.baseUrl}/${id}`);
  }

  // ✅ Create new brand
  create(payload: FormData | Brand): Observable<Brand> {
    return this.http.post<Brand>(this.baseUrl, payload);
  }

// ✅ Update brand by id
update(id: any, payload: FormData | Brand): Observable<Brand> {
  if (payload instanceof FormData) {
    payload.append('_method', 'PUT'); // مهم عشان Laravel يفهمها كـ PUT
    return this.http.post<Brand>(`${this.baseUrl}/${id}`, payload);
  } else {
    return this.http.put<Brand>(`${this.baseUrl}/${id}`, payload);
  }
}


  // ✅ Delete brand by id
  delete(id: any): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }
    updateLogo(id: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('brand_logo', file);

    return this.http.post(`${this.baseUrl}/${id}/update-logo`, formData);
  }
    getAllBrands(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/all`);
  }

  getAvailableSystemBrands(warehouseId: any): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/available-system-brands?warehouse_id=${warehouseId}`
    );
  }

  addExistingBrandsToWarehouse(warehouseId: any, brandIds: any[]): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/add-existing-to-warehouse`, {
      warehouse_id: warehouseId,
      brand_ids: brandIds,
    });
  }
  
}
